import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function ActivityLogPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/activity").then((r) => setItems(r.data.activity || [])).finally(() => setLoading(false));
  }, []);

  const actionBadge = (a) => {
    if (a === "create") return "bg-emerald-50 text-emerald-700 border-emerald-200";
    if (a === "update") return "bg-blue-50 text-blue-700 border-blue-200";
    if (a === "delete") return "bg-red-50 text-red-700 border-red-200";
    return "bg-slate-100 text-slate-700 border-slate-200";
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5" data-testid="activity-page">
      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Administration</div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mt-1">Activity Log</h1>
        <p className="text-sm text-slate-500 mt-1">Every change in the system is tracked.</p>
      </div>

      <Card className="border-slate-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                {["When", "User", "Action", "Module", "Record ID"].map((h) => (
                  <th key={h} className="text-left py-3 px-4 text-[11px] font-semibold uppercase tracking-wider text-slate-600">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={5} className="text-center py-10 text-slate-500">Loading...</td></tr>}
              {!loading && items.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-500">No activity yet</td></tr>}
              {!loading && items.map((i) => (
                <tr key={i._id} className="border-b border-slate-100 hover:bg-slate-50/60">
                  <td className="py-3 px-4 text-slate-600 whitespace-nowrap">{new Date(i.at).toLocaleString()}</td>
                  <td className="py-3 px-4 text-slate-700">{i.by_name || i.by_email}</td>
                  <td className="py-3 px-4"><Badge variant="outline" className={actionBadge(i.action)}>{i.action}</Badge></td>
                  <td className="py-3 px-4 text-slate-700">{i.module_key}</td>
                  <td className="py-3 px-4 text-slate-500 font-mono text-xs">{i.record_id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
